import React from 'react'

export default function RightArrow() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M9.21968 3.21967C9.51255 2.92678 9.98745 2.92678 10.2803 3.21967L15.5303 8.46968C15.8232 8.76255 15.8232 9.23745 15.5303 9.53033L10.2803 14.7803C9.98745 15.0732 9.51255 15.0732 9.21968 14.7803C8.9268 14.4875 8.9268 14.0126 9.21968 13.7197L13.1894 9.75H3C2.58579 9.75 2.25 9.41423 2.25 9C2.25 8.58578 2.58579 8.25 3 8.25H13.1894L9.21968 4.28033C8.9268 3.98743 8.9268 3.51257 9.21968 3.21967Z" fill="#00323D" />
    </svg>
  )
}
